import React from 'react';
import styled from 'styled-components';
import appStore from '../../../styles/images/app-store-badge.png';
import i18n from '../../../config/i18n';

const AppStoreIcon = styled.img`
  @media screen and (max-width: 480px) {
    height: 46px;
    object-fit: cover;
  }
`;

const StyledWrap = styled.div`
  padding: 0 !important;
  margin-top: 30px;

  @media screen and (max-width: 480px) {
    height: 50px;
    width: 230px;
    background: #000;
  }
`;

function AppStoreBtn() {
  return (
    <StyledWrap className="btn">
      <a href="https://itunes.apple.com/us/app/guruwounds/id1227365622">
        <AppStoreIcon
          alt={i18n.t('appStoreIcon')}
          src={appStore}
        />
      </a>
    </StyledWrap>
  );
}

export default AppStoreBtn;



// WEBPACK FOOTER //
// ./src/components/landing/HeroBanner/AppStoreBtn.js